import React from 'react'
import PropTypes from 'prop-types'

import {
  UpgradeProvider,
  useIntegrationPartner,
} from '@termly-web/common'

import ThemeSaver from 'containers/elements/modals/ThemeSaver'

import ModalProvider from 'components/ModalProvider'
import PolicyMigratorModal from 'components/PolicyMigratorModal'

import useCurrentUserPlanQuery from 'hooks/useCurrentUserPlanQuery'

import GateKeeper from './GateKeeper'

import Styles from './styles.scss'

// TODO: I'm not a fan of rendering all of these modals when we may
// never need them.
const MODALS = renderModals()


export default function Main({ children }) {
  const {
    isIntegrationPartner,
    upgrade,
  } = useIntegrationPartner()

  const { isPaidUser } = useCurrentUserPlanQuery()

  const handleUpgrade = ( isIntegrationPartner ) ? upgrade : void 0

  return (
    <GateKeeper>
      <UpgradeProvider
        handleUpgrade={ handleUpgrade }
        isUpgradable={ !isPaidUser }
      >
        <div className={ Styles.container }>
          <div className={ Styles.wrapper }>
            <ModalProvider>
              { children }
            </ModalProvider>

            { MODALS }
          </div>
        </div>
      </UpgradeProvider>
    </GateKeeper>
  )
}

Main.propTypes = {
  children: PropTypes.node,
}

Main.defaultProps = {
  children: null,
}

function renderModals() {
  // I'm reluctant to sort these because I have no idea if the ordering
  // is arbitrary or meaningful.
  return [
    <ThemeSaver key="ThemeSaver" />,
    <PolicyMigratorModal key="PolicyMigrator" />,
  ]
}
